export const STAKING_SC_ADDRESSES = [
    'erd1qqqqqqqqqqqqqpgqkympxgsafr4pkc7ms47gcaa9y0l9zyfw03aspv4l62', // KOSON
    'erd1qqqqqqqqqqqqqpgq8z74m4ua2mvx2ykg5pn6h5dwksqlukv603askmm3hl', // XLH
    'erd1qqqqqqqqqqqqqpgq2qtwwtt3h28a8pqcn7swe2pcthu4nzlr03asphugm6', // UTK
];

export const STAKING_COMMON_GAS_LIMIT = 30_000_000;
